module.exports = __webpack_public_path__ + "assets/img/1.b06c421f.png";